import { Component } from '@ecs/Component';
import { WeaponMode } from '@/types';

export type WeaponType = 'standard' | 'railgun';

export class Weapon implements Component {
  readonly type = 'Weapon';

  constructor(
    public lastShot: number = 0,
    public cooldown: number = 200,
    public range: number = 150,
    public energyCost: number = 10,
    public bulletSpeed: number = 8,
    public bulletColor: string = '#00ffff',
    public mode: WeaponMode = 'auto',
    public damage: number = 1,
    public weaponType: WeaponType = 'standard'
  ) {}
}